import React from "react";
import ReactDOM from "react-dom";
import "./index.css"; // Asegúrate de que este archivo sea importado
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
